/*
  Teeez continuous scroll for collection grids.
  The page keeps real ?page=N links in the HTML (rel="next"), so search engines
  and visitors without JavaScript can still reach every product. With
  JavaScript the next page loads automatically when the visitor nears the end
  of the grid, and the numbered page links are hidden.
*/
(() => {
  if (window.teeezShopAll) return;
  window.teeezShopAll = true;
  document.documentElement.classList.add('teeez-infinite');

  const STATE_KEY = 'teeez_scroll_' + location.pathname + location.search;
  let loading = false;
  let observer;

  const getRoot = () => document.querySelector('[data-body-root]');

  const sectionUrl = (href, sectionId) => {
    const url = new URL(href, location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  async function loadNext(link, opts = {}) {
    if (loading || !link) return false;
    const root = getRoot();
    if (!root) return false;
    loading = true;
    const label = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = link.dataset.loadingText || label;

    try {
      const res = await fetch(sectionUrl(link.href, root.dataset.sectionId), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-body-grid]');
      const newPagination = doc.querySelector('[data-body-pagination]');
      const grid = root.querySelector('[data-body-grid]');
      const pagination = root.querySelector('[data-body-pagination]');
      if (!newGrid || !grid) throw new Error('grid');

      const seen = new Set(Array.from(grid.querySelectorAll('[data-product-id], .product--root')).map((el) => el.dataset.productId || el.getAttribute('data-product-handle') || ''));
      const frag = document.createDocumentFragment();
      Array.from(newGrid.children).forEach((child) => {
        const id = child.dataset ? (child.dataset.productId || '') : '';
        if (id && seen.has(id)) return;
        frag.appendChild(child);
      });
      grid.appendChild(frag);

      if (pagination && newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
        pagination.querySelectorAll('script').forEach((s) => s.remove());
      }

      grid.dispatchEvent(new Event('productsUpdated'));
      window.dispatchEvent(new Event('theme:navigation:productsUpdated'));

      const pages = parseInt(sessionStorage.getItem(STATE_KEY + '_pages') || '1', 10) + 1;
      try { sessionStorage.setItem(STATE_KEY + '_pages', String(pages)); } catch (e) {}
      return true;
    } catch (e) {
      /* On any error fall back to a normal page load */
      if (!opts.silent) window.location.href = link.href;
      return false;
    } finally {
      loading = false;
      bind();
    }
  }

  function bind() {
    if (observer) observer.disconnect();
    const root = getRoot();
    if (!root) return;
    const link = root.querySelector('[data-teeez-next]');
    if (!link) return;

    if (!link.dataset.bound) {
      link.dataset.bound = 'true';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        loadNext(link);
      });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) loadNext(link);
      }, { rootMargin: '0px 0px 800px 0px' });
      observer.observe(link);
    }
  }

  /* Back button: reload the pages the visitor had loaded and restore position */
  async function restore() {
    let nav;
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) {}
    const isBack = nav && nav.type === 'back_forward';
    if (!isBack) {
      try {
        sessionStorage.removeItem(STATE_KEY + '_pages');
        sessionStorage.removeItem(STATE_KEY + '_y');
      } catch (e) {}
      return;
    }
    const pages = parseInt(sessionStorage.getItem(STATE_KEY + '_pages') || '1', 10);
    const y = parseInt(sessionStorage.getItem(STATE_KEY + '_y') || '0', 10);
    try { sessionStorage.setItem(STATE_KEY + '_pages', '1'); } catch (e) {}
    for (let i = 1; i < pages; i++) {
      const link = document.querySelector('[data-body-root] [data-teeez-next]');
      if (!link) break;
      const ok = await loadNext(link, { silent: true });
      if (!ok) break;
    }
    if (y) window.scrollTo(0, y);
  }

  window.addEventListener('pagehide', () => {
    try { sessionStorage.setItem(STATE_KEY + '_y', String(Math.round(window.scrollY))); } catch (e) {}
  });

  /* Re-bind after the theme replaces the grid (filters and sorting) */
  const start = () => {
    const root = getRoot();
    if (!root) return;
    new MutationObserver(() => {
      const link = root.querySelector('[data-teeez-next]');
      if (link && !link.dataset.bound) bind();
    }).observe(root, { childList: true, subtree: true });
    restore().then(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
